import { render, staticRenderFns } from "./ToggleDisallowWarranty.vue?vue&type=template&id=4dcf6c8a&scoped=true"
import script from "./ToggleDisallowWarranty.vue?vue&type=script&lang=ts"
export * from "./ToggleDisallowWarranty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf6c8a",
  null
  
)

export default component.exports